export default "__VITE_ASSET__BANn704m__"